import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";
import { buildCrudPermissions, permissionId } from "../../shared/featureFactories";

export const ChequesFeature: FeatureMetadata = {
  id: "cheques",
  moduleName: "feesFinance",
  navigation: {
    label: "Cheque Management",
    path: "/cheques",
    icon: DocumentTextIcon,
    order: 8,
  },
  route: {
    path: "/cheques",
    element: lazy(() => import("./pages/ChequeManagement")),
  },
  permissions: buildCrudPermissions("FeeFinance", "Cheques", {
    view: permissionId("FeeFinance", "Cheques", "view"),
    create: permissionId("FeeFinance", "Cheques", "manage"),
    edit: permissionId("FeeFinance", "Cheques", "manage"),
    delete: permissionId("FeeFinance", "Cheques", "manage"),
  }),
  readiness: "live",
};
